module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAnklEQVR4nO3YwQ0CIRAF0FEb0A4sxVJswQ4s0U6WDjSbEOMGPO5uwryXcAESmIHTDwAA+LpHxBQR78HGVGtbOHTefd54bmbHUCLi8lvJMfvH7zXgUTs1mlJrAwAgvfTSSy+99NL7RyYoE0yk1wCZIAAAAMBKnp3cbvNMcC/XzgW3asJCLxJL5bRTsaUm0rdmZd0z50zw1awAAJBNRHwAjga0cPrkjMsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_menu@2x.png
// module id = 708
// module chunks = 0